export default "__VITE_ASSET__1FXSL0sc__"